module.exports = function() {
  return new Worker(__webpack_public_path__ + "ce1d529f66ecc6cdb929.worker.js");
};